// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, listByResourceGroup, $delete, update, create, get } from "./operations.js";
export type {
  FleetListOptionalParams,
  FleetListByResourceGroupOptionalParams,
  FleetDeleteOptionalParams,
  FleetUpdateOptionalParams,
  FleetCreateOptionalParams,
  FleetGetOptionalParams,
} from "./options.js";
